module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av435-1610d9201d1b73781ab997bc3ce8db23.jpg";